import { EventSeriesCadenceUnit } from 'types/EventSeries';

const PLACEHOLDER_KEY_BY_UNIT: Record<EventSeriesCadenceUnit, string> = {
  days: 'general.enter_number_of_days',
  months: 'general.enter_number_of_months',
  weeks: 'general.enter_number_of_weeks',
  years: 'general.enter_number_of_years',
};

export const unitPlaceholderKey = (unit: EventSeriesCadenceUnit): string => PLACEHOLDER_KEY_BY_UNIT[unit];
